const dataScience = {
    id2000: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 1ᵉ planète du système solaire ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2001: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Mercure dans le système solaire ?",
      answers: ["1","8","6","4"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2002: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 57.91 millions de km du Soleil ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2003: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Mercure par rapport au Soleil (en millions de km) ?",
      answers: ["2877","227.9","57.91","4503"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2004: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 4879 km ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2005: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Mercure (en km) ?",
      answers: ["4879","49244","50724","116464"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2006: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 0 lune ?",
      answers: ["Neptune","Mars","Uranus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2007: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Mercure ?",
      answers: ["83","0","14","27"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2008: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -173 °C ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2009: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Mercure (en °C) ?",
      answers: ["-173","-89","462","-153"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2010: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ 427 °C ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2011: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Mercure (en °C) ?",
      answers: ["58","427","20","-140"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2012: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 88 jours ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2013: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Mercure (en jours) ?",
      answers: ["687","224.7","30687","88"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2014: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 1407.6 heures ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2015: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Mercure (en heures) ?",
      answers: ["-17.24","16.11","-5832.5","1407.6"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2016: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 3.7 m/s² ?",
      answers: ["Neptune","Mars","Vénus","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2017: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Mercure (en m/s²) ?",
      answers: ["3.7","9.81","8.87","3.72"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2018: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est connue depuis l'Antiquité ?",
      answers: ["Neptune","Uranus","Aucune de ces réponses","Mercure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2019: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Mercure a-t-elle été découverte ?",
      answers: ["23 septembre 1846","6 janvier 901","Connue depuis l'Antiquité","13 mars 1781"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2022: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 2ᵉ planète du système solaire ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2023: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Vénus dans le système solaire ?",
      answers: ["8","2","1","5"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2024: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 108.2 millions de km du Soleil ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2025: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Vénus par rapport au Soleil (en millions de km) ?",
      answers: ["57.91","2877","108.2","227.9"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2026: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 12104 km ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2027: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Vénus (en km) ?",
      answers: ["139822","12104","49244","6792"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2028: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 0 lune ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2029: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Vénus ?",
      answers: ["27","0","83","1"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2030: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ 462 °C ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2031: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Vénus (en °C) ?",
      answers: ["462","-224","-89","-201"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2032: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ 490 °C ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2033: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Vénus (en °C) ?",
      answers: ["427","58","490","-140"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2034: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 224.7 jours ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2035: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Vénus (en jours) ?",
      answers: ["30687","687","59800","224.7"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2036: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 5832.5 heures ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2037: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Vénus (en heures) ?",
      answers: ["10.55","-5832.5","-17.24","16.11"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2038: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 8.87 m/s² ?",
      answers: ["Vénus","Neptune","Uranus","Saturne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2039: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Vénus (en m/s²) ?",
      answers: ["3.72","9.81","8.87","24.79"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2040: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est connue depuis l'Antiquité ?",
      answers: ["Vénus","Neptune","Uranus","Aucune de ces réponses"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2041: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Vénus a-t-elle été découverte ?",
      answers: ["13 mars 1781","Connue depuis l'Antiquité","26 février 453","23 septembre 1846"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2044: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 3ᵉ planète du système solaire ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2045: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Terre dans le système solaire ?",
      answers: ["1","2","3","8"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2046: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 149.6 millions de km du Soleil ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2047: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de la Terre par rapport au Soleil (en millions de km) ?",
      answers: ["2877","149.6","1433","227.9"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2048: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 12756 km ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2049: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de la Terre (en km) ?",
      answers: ["12104","12756","4879","116464"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2050: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 1 lune ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2051: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a la Terre ?",
      answers: ["0","2","14","1"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2052: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -89 °C ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2053: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de la Terre (en °C) ?",
      answers: ["-89","-173","462","-153"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2054: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ 58 °C ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2055: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de la Terre (en °C) ?",
      answers: ["462","24","58","427"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2056: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 365.25 jours ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2057: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de la Terre (en jours) ?",
      answers: ["224.7","687","365.25","10759"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2058: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 23.93 heures ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2059: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de la Terre (en heures) ?",
      answers: ["10.55","16.11","1407.6","23.93"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2060: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 9.81 m/s² ?",
      answers: ["Mercure","Uranus","Vénus","Terre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2061: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de la Terre (en m/s²) ?",
      answers: ["8.87","24.79","10.44","9.81"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2066: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 4ᵉ planète du système solaire ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2067: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Mars dans le système solaire ?",
      answers: ["4","2","7","1"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2068: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 227.9 millions de km du Soleil ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2069: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Mars par rapport au Soleil (en millions de km) ?",
      answers: ["227.9","1433","108.2","2877"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2070: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 6792 km ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2071: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Mars (en km) ?",
      answers: ["116464","139822","50724","6792"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2072: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 2 lunes ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2073: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Mars ?",
      answers: ["2","0","1","27"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2074: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -153 °C ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2075: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Mars (en °C) ?",
      answers: ["-153","-201","-173","462"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2076: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ 20 °C ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2077: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Mars (en °C) ?",
      answers: ["-140","58","462","20"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2078: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 687 jours ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2079: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Mars (en jours) ?",
      answers: ["30687","687","10759","224.7"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2080: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 24.62 heures ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2081: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Mars (en heures) ?",
      answers: ["24.62","9.93","-17.24","10.55"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2082: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 3.72 m/s² ?",
      answers: ["Mars","Vénus","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2083: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Mars (en m/s²) ?",
      answers: ["8.87","24.79","9.81","3.72"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2084: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est connue depuis l'Antiquité ?",
      answers: ["Mars","Aucune de ces réponses","Uranus","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2085: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Mars a-t-elle été découverte ?",
      answers: ["2 mars 1453","13 mars 1781","Connue depuis l'Antiquité","23 septembre 1846"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2088: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 5ᵉ planète du système solaire ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2089: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Jupiter dans le système solaire ?",
      answers: ["5","3","4","8"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2090: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 778.5 millions de km du Soleil ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2091: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Jupiter par rapport au Soleil (en millions de km) ?",
      answers: ["4503","227.9","108.2","778.5"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2092: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 139822 km ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2093: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Jupiter (en km) ?",
      answers: ["139822","6792","50724","116464"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2094: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 95 lunes ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2095: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Jupiter ?",
      answers: ["95","0","1","2"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2096: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -145 °C ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2097: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Jupiter (en °C) ?",
      answers: ["-89","-153","-145","462"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2098: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ 24 °C ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2099: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Jupiter (en °C) ?",
      answers: ["-200","462","24","-216"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2100: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 4333 jours ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2101: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Jupiter (en jours) ?",
      answers: ["59800","365.25","687","4333"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2102: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 9.93 heures ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2103: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Jupiter (en heures) ?",
      answers: ["9.93","10.55","-5832.5","24.62"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2104: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 24.79 m/s² ?",
      answers: ["Jupiter","Mercure","Saturne","Uranus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2105: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Jupiter (en m/s²) ?",
      answers: ["8.69","11.15","9.81","24.79"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2106: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est connue depuis l'Antiquité ?",
      answers: ["Jupiter","Uranus","Aucune de ces réponses","Neptune"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2107: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Jupiter a-t-elle été découverte ?",
      answers: ["Connue depuis l'Antiquité","13 mars 1781","23 septembre 1846","15 octobre 1809"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2110: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 6ᵉ planète du système solaire ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2111: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Saturne dans le système solaire ?",
      answers: ["1","2","6","7"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2112: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 1433 millions de km du Soleil ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2113: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Saturne par rapport au Soleil (en millions de km) ?",
      answers: ["778.5","1433","4503","227.9"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2114: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 116464 km ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2115: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Saturne (en km) ?",
      answers: ["49244","6792","4879","116464"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2116: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 83 lunes ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2117: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Saturne ?",
      answers: ["83","0","95","2"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2118: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -184 °C ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2119: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Saturne (en °C) ?",
      answers: ["-184","-201","-145","-153"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2120: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ -140 °C ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2121: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Saturne (en °C) ?",
      answers: ["427","24","-140","58"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2122: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 10759 jours ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2123: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Saturne (en jours) ?",
      answers: ["10759","4333","30687","365.25"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2124: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 10.55 heures ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2125: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Saturne (en heures) ?",
      answers: ["16.11","24.62","10.55","9.93"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2126: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 10.44 m/s² ?",
      answers: ["Saturne","Uranus","Mars","Jupiter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2127: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Saturne (en m/s²) ?",
      answers: ["8.87","3.72","10.44","9.81"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2128: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est connue depuis l'Antiquité ?",
      answers: ["Saturne","Uranus","Neptune","Aucune de ces réponses"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2129: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Saturne a-t-elle été découverte ?",
      answers: ["23 septembre 1846","13 mars 1781","Connue depuis l'Antiquité","13 décembre 1781"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2132: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 7ᵉ planète du système solaire ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2133: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Uranus dans le système solaire ?",
      answers: ["5","3","7","1"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2134: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 2877 millions de km du Soleil ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2135: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne d'Uranus par rapport au Soleil (en millions de km) ?",
      answers: ["227.9","778.5","2877","57.91"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2136: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 50724 km ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2137: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre d'Uranus (en km) ?",
      answers: ["12756","50724","49244","6792"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2138: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 27 lunes ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2139: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Uranus ?",
      answers: ["27","1","83","0"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2140: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -224 °C ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2141: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale d'Uranus (en °C) ?",
      answers: ["-173","-145","-224","-201"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2142: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ -216 °C ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2143: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale d'Uranus (en °C) ?",
      answers: ["427","462","-216","58"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2144: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 30687 jours ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2145: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution d'Uranus (en jours) ?",
      answers: ["30687","687","88","224.7"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2146: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 17.24 heures ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2147: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation d'Uranus (en heures) ?",
      answers: ["1407.6","16.11","-17.24","10.55"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2148: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 8.69 m/s² ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2149: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité d'Uranus (en m/s²) ?",
      answers: ["3.7","9.81","3.72","8.69"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2150: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a été découverte le 13 mars 1781 ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2151: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Uranus a-t-elle été découverte ?",
      answers: ["Connue depuis l'Antiquité","23 septembre 1846","13 mars 1781","23 septembre 1864"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2152: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a été découverte par William Herschel ?",
      answers: ["Neptune","Uranus","Mars","Jupiter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2153: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Qui a découvert la planète Uranus ?",
      answers: ["Thomas Harriot","Johann Galle","William Herschel","Galilée"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2154: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la 8ᵉ planète du système solaire ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2155: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la position de la planète Neptune dans le système solaire ?",
      answers: ["6","4","2","8"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2156: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète est à environ 4503 millions de km du Soleil ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2157: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance moyenne de Neptune par rapport au Soleil (en millions de km) ?",
      answers: ["1433","227.9","778.5","4503"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id2158: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a un diamètre d'environ 49244 km ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2159: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de Neptune (en km) ?",
      answers: ["49244","139822","12756","116464"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2160: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a 14 lunes ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2161: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Combien de lunes a Neptune ?",
      answers: ["14","1","83","0"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2162: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température minimale d'environ -201 °C ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2163: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température minimale de Neptune (en °C) ?",
      answers: ["-201","-224","-145","-153"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2164: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une température maximale d'environ -200 °C ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2165: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la température maximale de Neptune (en °C) ?",
      answers: ["427","20","-200","-140"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2166: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de révolution d'environ 59800 jours ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2167: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de Neptune (en jours) ?",
      answers: ["10759","59800","4333","224.7"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2168: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une période de rotation d'environ 16.11 heures ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2169: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de rotation de Neptune (en heures) ?",
      answers: ["16.11","-17.24","-5832.5","9.93"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2170: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a une gravité d'environ 11.15 m/s² ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2171: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de Neptune (en m/s²) ?",
      answers: ["3.7","8.69","11.15","24.79"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2172: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a été découverte le 23 septembre 1846 ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2173: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quand la planète Neptune a-t-elle été découverte ?",
      answers: ["Connue depuis l'Antiquité","13 mars 1718","23 septembre 1846","13 mars 1781"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2174: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle planète a été découverte par Johann Galle ?",
      answers: ["Vénus","Neptune","Jupiter","Mars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2175: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Qui a découvert la planète Neptune ?",
      answers: ["Thomas Harriot","William Herschel","Johann Galle","Galilée"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2176: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle galaxie a un diamètre d'environ 100000 années-lumière ?",
      answers: ["Voie Lactée","Grand Nuage de Magellan","Andromède","Nébuleuse d'Orion"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2177: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de la galaxie Voie Lactée (en années-lumière) ?",
      answers: ["100000","220000", "330000","440000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2178: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Dans quelle galaxie se trouve la Terre ?",
      answers: ["Voie Lactée","Grand Nuage de Magellan","Andromède","Nébuleuse d'Orion"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2179: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance de la galaxie Voie Lactée par rapport à la Terre (en millions d'années-lumière) ?",
      answers: ["2.54","0", "20", "254"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2180: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle galaxie a un diamètre d'environ 220000 années-lumière ?",
      answers: ["Voie Lactée","Grand Nuage de Magellan","Andromède","Nébuleuse d'Orion"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2181: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de la galaxie Andromède (en années-lumière) ?",
      answers: ["100000","220000", "330000","440000"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2182: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle galaxie est à environ 2.54 millions d'années-lumière de la Terre ?",
      answers: ["Voie Lactée","Grand Nuage de Magellan","Andromède","Nébuleuse d'Orion"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2183: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la distance de la galaxie Andromède par rapport à la Terre (en millions d'années-lumière) ?",
      answers: ["2.54","0", "20", "254"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2184: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a un diamètre d'environ 946 km ?",
      answers: ["Juno","Cérès","Vesta","Pallas"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2185: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de l'astéroïde Cérès (en km) ?",
      answers: ["946","525","110","8000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2186: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a une période de révolution d'environ 1682 jours ?",
      answers: ["Juno","Cérès","Vesta","Pallas"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2187: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de l'astéroïde Cérès (en jours) ?",
      answers: ["1325","1682","42","3602"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2188: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a une gravité d'environ 0.28 m/s² ?",
      answers: ["Juno","Cérès","Vesta","Pallas"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2189: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de l'astéroïde Cérès (en m/s²) ?",
      answers: ["0.28","0.22","0.01","0.8"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id2190: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a un diamètre d'environ 525 km ?",
      answers: ["Pallas","Juno","Vesta","Cérès"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2191: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel est le diamètre de l'astéroïde Vesta (en km) ?",
      answers: ["946","525","437","255"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2192: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a une période de révolution d'environ 1325 jours ?",
      answers: ["Pallas","Juno","Vesta","Cérès"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2193: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la période de révolution de l'astéroïde Vesta (en jours) ?",
      answers: ["1682","1325","1862","1235"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id2194: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quel astéroïde a une gravité d'environ 0.22 m/s² ?",
      answers: ["Pallas","Juno","Vesta","Cérès"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id2195: {
      themes: ["Science et Nature","Astronomie","Divers"],
      question: "Quelle est la gravité de l'astéroïde Vesta (en m/s²) ?",
      answers: ["0.28","0.22","0.82","2.2"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },

    id2200: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle région d’Espagne est originaire le cheval andalou ?",
    answers: ["Andalousie","Catalogne","Galice","Castille-La Manche"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2201: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race de cheval est originaire d'andalousie ?",
    answers: ["Andalou","Appaloosa","Falabella","Shetland"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2202: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel autre nom est couramment utilisé pour désigner le cheval andalou ?",
    answers: ["Lusitanien","Pure race espagnole","Frison ibérique","Cheval castillan"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
    id2203: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race est aussi désigner par le Pure race espagnole'?",
    answers: ["Mustang","Haflinger","Carmaguais","Andalou"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
    id2204: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel rôle historique le cheval andalou a-t-il principalement joué en Europe ?",
    answers: ["cheval de trait agricole","cheval de mine","cheval de guerre et de cour royale","cheval de course populaire"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2205: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Pour quelle discipline le cheval andalou est-il particulièrement réputé ?",
    answers: ["le dressage","les courses de galop","le saut d’obstacles","les courses de trot attelé"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2206: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel est le nom du cheval légendaire de Rodrigo Díaz, héros de la Reconquête espagnole ?",
    answers: ["Rocinante","Babieca","Brillante","Xanthos"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
    id2207: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "À quel héros historique Babieca est-il associé ?",
    answers: ["Alphonse VI","Bernard de Clairvaux","Rodrigo Díaz","Guillaume le Conquérant"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2208: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Lors de quel conflit Babieca se distingua-t-il aux côtés de son maître ?",
    answers: ["les croisades","la guerre de Cent Ans","la bataille de Hastings","la Reconquête espagnole"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
    id2209: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "À quel siècle Babieca est-il supposé avoir vécu ?",
    answers: ["IXe siècle","XIe siècle","XIIIe siècle","XVe siècle"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
    id2210: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle œuvre littéraire de Corneille s’inspire de la figure de Rodrigo Díaz, cavalier de Babieca ?",
    answers: ["Horace","Cinna","Le Cid","Polyeucte"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2211: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race est traditionnellement attribuée à Babieca ?",
    answers: ["arabe","frison","percheron","andalou"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
    id2212: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quels croisements est issue la race anglo-arabe ?",
    answers: ["arabe et andalou","arabe et pur-sang anglais","arabe et frison","arabe et percheron"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
    id2213: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la race issue du croisement entre le cheval arabe et le pur-sang anglais ?",
    answers: ["percheron","frison","anglo-arabe","quarter-horse"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2214: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quel pays la race anglo-arabe a-t-elle été développée à l’origine ?",
    answers: ["France","Espagne","Royaume-Uni","Maroc"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2215: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel peuple amérindien est historiquement associé au développement du cheval Appaloosa ?",
    answers: ["les Comanches","les Nez-Percés","les Sioux","les Apaches"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
    id2216: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "A quelle race de cheval est associée la tribu indienne des Nez-Percés",
    answers: ["Barbe","Andalou","Lipizzan","Appaloosa"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
    id2217: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle caractéristique de robe est typique du cheval Appaloosa ?",
    answers: ["tachetée","baie","noire","alezane"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2218: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel état des États-Unis le cheval Appaloosa est-il originaire ?",
    answers: ["Indiana","Texas","Idaho","Wisconsin"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2219: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race de cheval docile est originaire de l'Idaho (Etats-Unis)",
    answers: ["Clydesdale","Mustang","Appaloosa","Quarter Horse"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2220: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle région du monde est originaire le pur-sang arabe ?",
    answers: ["la péninsule Arabique","l’Asie centrale","l’Afrique du Nord","l’Europe orientale"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
    id2221: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle particularité anatomique distingue souvent le pur-sang arabe des autres races ?",
    answers: ["des sabots beaucoup plus larges","une absence totale de fanons","un nombre réduit de vertèbres et de côtes","un cœur plus petit que la moyenne"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
    id2222: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Selon la légende, quelle race descendrait d'un étalon nommé Hosaba et d'une jument nommmé Baz, capturée au Yémen par Bax, l'arrière-arrière-petit-fils de Noé ?",
    answers: ["Berbère","Percheron","Arabe","Trakehner"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
   id2223: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Selon la légende, en plus du cheval du Don, quelle autre race aurait résister au terrible hiver pendant la campagne de Russie de Napoléon de 1812 ?",
    answers: ["Breton","Ardennais","Camarguais","Selle français"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2224: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle race rustiques, durs et infatigables Jules César fait-il mention à l’époque de la guerre des Gaules ?",
    answers: ["Berbère","Andalou","Arabe","Ardennais"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
   id2225: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle région du monde est originaire le cheval Barbe ?",
    answers: ["l’Afrique du Nord","l'Amérique du Sud","l’Asie centrale","l’Europe de l’Est"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
   id2226: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle race est la monture traditionnelle des Spahis, soldats indigènes qui servaient autrefois dans la cavalerie française en Afrique du Nord ?",
    answers: ["Frison","Percheron","Arabe","Barbe"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
   id2227: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "D'après quel nom la race Barbe a-t-elle été baptisé ?",
    answers: ["Bar-Le-Duc","Barbarie","Barbades","Barbès"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2228: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel autre nom donne-t-on à la race Barbe",
    answers: ["Barbie","Barbichette","Berbère","Barbare"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
   id2229: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race est surnommé pur-sang des chevaux de trait ou colosse de marbre ?",
    answers: ["Shire","Clydesdale","Breton","Boulonnais"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
   id2230: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on le type de petit Boulonnais qui assurait le transport des poissons frais ?",
    answers: ["le mareyeur","le roulier","le charbonnier","le palefrenier"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
   id2231: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel localité vient la race de cheval Boulonnais ?",
    answers: ["Boulogne-sur-Mer","Boulleret","Bouloir","Bouligny"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
   id2232: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel race est traditionnellement marquée d'une ancre marine, appliquée sur le côté gauche de l'encolure ?",
    answers: ["Breton","Boulonnais","Camarguais","Trotteur français"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2233: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel objet est traditionnellement marquée au fer sur le côté gauche de l'encolure du Boulonnais ?",
    answers: ["Une faux","Une cravache","Une ancre marine","Une roue"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
   id2234: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle ville se situe le berceau historique et le haras national emblématique du cheval Breton ?",
    answers: ["Saint-Lô","Hennebont","Lamballe","Saumur"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2235: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on le type de Breton plus léger et plus rapide, autrefois utilisé pour les diligences ?",
    answers: ["Le Postier","Le Trait","Le Galopeur","Le Sommier"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2236: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Historiquement, le Postier Breton possède des ancêtres issus de quelle race anglaise pour améliorer ses allures ?",
    answers: ["Shire","Norfolk Trotter","Thoroughbred","Shetland"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2237: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle inscription est marquée au fer sur le côté gauche de l'encolure pour les Bretons inscrits au stud-book, registre officiel ?",
    answers: ["Une croix","Une ancre marine","Une hermine","Une roue"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2238: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la couleur de robe caractéristique du cheval Camarguais à l'âge adulte ?",
    answers: ["Noir","Bai","Gris","Alezan"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2239: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on le cavalier qui utilise traditionnellement le cheval Camarguais pour garder les taureaux ?",
    answers: ["Le Gaucho","Le Gardian","Le Manadier","Le Cowboy"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2240: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on l'élevage en liberté d'un troupeau de chevaux Camarguais ?",
    answers: ["Une manade","Une estive","Une harde","Un enclos"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2241: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race de cheval est souvent surnommé le cheval blanc de la mer ?",
    answers: ["Lippizan","Camarguais","Percheron","Connemara"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2242: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel outil le cavalier Camarguais utilise-t-il pour conduire le bétail ?",
    answers: ["La pique","Le lasso","La fourche","Le trident"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2243: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "A quelle race de cheval appartient le cheval principal dans le film Crin-Blanc ?",
    answers: ["Pur-sang anglais","Paint","Camarguais","Mustang"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2244: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quel département français se situe la majeure partie du berceau de la race Camarguaise ?",
    answers: ["L'Hérault","Le Gard","Les Bouches-du-Rhône","Le Vaucluse"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2245: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire la race de cheval de trait Clydesdale ?",
    answers: ["Irlande","Écosse","Pays de Galles","Angleterre"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2246: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la couleur de robe la plus courante chez le Clydesdale ?",
    answers: ["Bai","Alezan brûlé","Gris souris","Pie noir"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2247: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire la race de cheval Frison ?",
    answers: ["Belgique","Allemagne","Pays-Bas","Danemark"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2248: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la seule couleur de robe officiellement admise pour l'inscription au stud-book du Frison ?",
    answers: ["Gris","Noir","Bai","Alezan"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2249: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle province des Pays-Bas la race a-t-elle vu le jour ?",
    answers: ["Hollande","Zélande","Frise","Groningue"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2250: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la race de cheval favori des reines dont Béatrix de Hollande",
    answers: ["Camarguais","Appaloosa","Pur-sang anglais","Frison"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2251: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays actuel la race Lipizzan tire-t-elle son nom (du village de Lipica) ?",
    answers: ["Autriche","Slovénie","Hongrie","Espagne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2252: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle institution équestre mondialement célèbre, située à Vienne, utilise exclusivement des étalons Lipizzans ?",
    answers: ["Le Cadre Noir","L'École Espagnole","Le Royal Andalou","Le Haras de Pompadour"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2253: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la couleur de robe quasi exclusive du Lipizzan à l'âge adulte ?",
    answers: ["Bai","Noir","Gris","Alezan"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2254: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Parmi ces figures de Haute École, laquelle est une spécialité de saut d'école du Lipizzan ?",
    answers: ["La cabriole","Le galop arrière","Le spin","Le sliding stop"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2255: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la figure où le Lipizzan se dresse sur ses membres postérieurs selon un angle de 45 degrés ?",
    answers: ["La pesade","La levade","La courbette","La croupade"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2256: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle races d'étalons à l'origine des Lipizzans a été importé d'Espagne au XVIe siècle par l'archiduc Charles II ?",
    answers: ["Arabe","Appaloosa","Trakehner","Andalou"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2257: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays les ancêtres du Mustang ont-ils été introduits sur le continent américain au XVIe siècle ?",
    answers: ["Angleterre","Espagne","France","Portugal"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2258: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel terme biologique définit un animal domestique retourné à l'état sauvage, comme c'est le cas pour le Mustang ?",
    answers: ["Endémique","Féral","Hybride","Autochtone"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2259: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel organisme gouvernemental américain est chargé de la gestion et de la protection des populations de Mustangs ?",
    answers: ["FBI","BLM","NASA","WWF"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2260: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les rassemblements de Mustangs sauvages organisés par hélicoptère pour réguler leur nombre ?",
    answers: ["gathers","rodéos","transhumances","battues"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2261: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle partie des États-Unis trouve-t-on la grande majorité des Mustangs sauvages aujourd'hui ?",
    answers: ["La Floride","L'Ouest américain","La Nouvelle-Angleterre","La Louisiane"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2262: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire la race de cheval Paint ?",
    answers: ["Espagne","Mexique","Canada","États-Unis"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2263: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on le motif de robe de la race Paint où le blanc ne traverse pas la ligne du dos ?",
    answers: ["Overo","Tobiano","Tovero","Sabino"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2264: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel nom porte le motif de robe de la race Paint caractérisé par des plaques blanches verticales traversant souvent la ligne du dos ?",
    answers: ["Appaloosa","Tobiano","Bai","Rouan"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2265: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on un Paint Horse qui possède des caractéristiques des motifs Tobiano et Overo ?",
    answers: ["Mix-color","Tovero","Tricolore","Pie-bald"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2266: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel peuple amérindien ont adopté la race de cheval Paint comme race principale ?",
    answers: ["Les Mayas","Les Incas","Les Comanches","Les Inuits"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2267: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on un cheval Paint de pure race mais qui naît avec une robe de couleur unie ?",
    answers: ["Solid Paint Bred","Quarter Horse","Albino","Paint-vide"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2268: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle région française le cheval Percheron est-il originaire ?",
    answers: ["La Bretagne","La Normandie","La Picardie","La Camargue"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2269: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on le type de Percheron léger, autrefois utilisé pour tirer les omnibus parisiens ?",
    answers: ["Le Diligencier","Le Trotteur","Le Postier","Le Voltigeur"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2270: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle ville française accueille traditionnellement le Mondial du Percheron ?",
    answers: ["Nogent-le-Rotrou","Alençon","Mortagne-au-Perche","Le Pin-au-Haras"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2271: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Combien d'étalons fondateurs orientaux sont à l'origine de tous les Pur-sang anglais actuels ?",
    answers: ["3","10","25","50"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2272: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la vitesse de pointe approximative que peut atteindre un Pur-sang anglais en course ?",
    answers: ["40 km/h","70 km/h","100 km/h","120 km/h"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2273: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment s'appelle l'organisme qui gère le registre généalogique mondial des Pur-sang anglais ?",
    answers: ["Le Stud-Book","Le General Stud Book","Le Jockey Club","L'IFCE"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2274: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre cheval de course Pur-sang est devenu une légende aux États-Unis dans les années 30 et a eu un film à son nom ?",
    answers: ["Ourasi","Jappeloup","Seabiscuit","Tornado"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2275: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment s'appelle l'étalon, parmis les fondateurs de la race Pur-sang, offert à Louis XV par le bey du Maroc en 1730 ?",
    answers: ["Byerley Turk","Darley Arabian","Godolphin Arabian","Marengo"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2276: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers", "Art"],
    question: "Quel tableau de Rosa Bonheur a été inspiré par la légende du Godolphin Arabian ?",
    answers: ["Cheval","Relais de chasse","Le Duel","Le Marché aux chevaux"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2277: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on l'instinct naturel du Quarter Horse pour anticiper les mouvements du bétail ?",
    answers: ["Bull-Eye","Cow Sense","Herd-Control","Cattle-Spirit"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2278: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle discipline de l'équitation Western consiste à guider le cheval pour effectuer des cercles, des pirouettes et des arrêts glissés ?",
    answers: ["Le Reining","Le Barrel Racing","Le Cutting","Le Trail"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2279: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel est l'organisme mondial basé au Texas qui gère le registre du Quarter Horse ?",
    answers: ["L'AQHA","La FEI","La Western Society","Le Jockey Club"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2280: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle discipline consiste à tourner le plus rapidement possible autour de trois tonneaux ?",
    answers: ["Le Reining","Le Cutting","Le Barrel Racing","Le Pleasure"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2281: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel état des États-Unis le Quarter Horse est-il originaire ?",
    answers: ["Indiana","Texas","Virginie","Tennessee"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2282: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle race de cheval est originaire de Virginie (Etats-Unis)",
    answers: ["Clydesdale","Mustang","Appaloosa","Quarter Horse"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2283: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel état des États-Unis le rodéo est-il né en 1888 ?",
    answers: ["Arizona","Texas","Virginie","Idaho"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2284: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "En quelle année la race du Selle Français a-t-elle été officiellement créée par la fusion de plusieurs races régionales ?",
    answers: ["1850","1914","1958","2000"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2285: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre petit étalon Selle Français a été sacré champion olympique en 1988 avec Pierre Durand ?",
    answers: ["Galoùbet A","Jappeloup","Baloubet du Rouet","Itot du Château"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2286: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle région française se situe le berceau historique de l'élevage du Selle Français ?",
    answers: ["Normandie","Provence","Bretagne","Pays Basque"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2287: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle région française se situe le haras du Pin ?",
    answers: ["Occitanie","Bretagne","Grand Est","Normandie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2288: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les chevaux Selle Français plus légers possèdant d'avantage de sang pur-sang ?",
    answers: ["AQPS","Trotteurs","Cobs","Hunters"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2289: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre cheval anglo-normand a été sacré champion olympique en 1964 à Tokyo en compagnie de son cavalier Pierre Jonquères d'Oriola ?",
    answers: ["Lutteur B","Jappeloup","Baloubet du Rouet","Itot du Château"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2290: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel cavalier a remporté la médaille d'or aux jeux olympiques de 1964 à Tokyo avec le cheval anglo-normand Lutteur B ?",
    answers: ["Pierre Durand","Aimé Haegeman","Jean Cariou","Pierre Jonquères d'Oriola"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2291: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire le Shire ?",
    answers: ["Écosse","Angleterre","Irlande","Pays-Bas"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2292: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment s'appelait le célèbre Shire qui détient le record historique du plus grand cheval du monde (2,19 m) ?",
    answers: ["Sampson","Goliath","Major","Titan"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2293: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel race de descend des chevaux flamands et frisons ainsi que des chevaux de traits britanniques comme le Great Horse ?",
    answers: ["Percheron","Clydesdale","Shire","Breton"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2294: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle marque au fer rouge, représentant un bois d'élan, est traditionnellement apposée sur la cuisse des Trakehner ?",
    answers: ["Une couronne","Une ancre","Une ramure d'élan","Une étoile"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2295: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre étalon est un Trakehner ayant marqué le dressage moderne notamment avec Edward Gal ?",
    answers: ["Milton","Totilas","Gribaldi","Jappeloup"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2296: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre cheval a été le principal étalon du haras de Trakehnen et a eu une statue en bronze érigée devant le château de Trakehnen en 1932 ?",
    answers: ["Tempelhüter","Sampson","Gribaldi","Jappeloup"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2297: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle région française la race du Trotteur Français a-t-elle principalement été développée au XIXe siècle ?",
    answers: ["La Camargue","La Normandie","L'Aquitaine","La Bretagne"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2298: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre étalon, surnommé 'Le Roi de Vincennes', a remporté quatre fois le Prix d'Amérique dans les années 80 ?",
    answers: ["Général du Pommeau","Bellino II","Bold Eagle","Ourasi"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2299: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle course est considérée comme le championnat du monde de trot attelé sur l'hippodrome de Vincennes ?",
    answers: ["Le Prix de Diane","Le Prix d'Amérique","Le Grand Steeple-Chase","Le Prix de l'Arc de Triomphe"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2300: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la voiture légère à deux roues utilisée pour les courses de trot attelé ?",
    answers: ["Un cabriolet","Un sulky","Une charrette","Un break"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2301: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle ville sont organisés les premières courses françaises de trot attelé et monté ?",
    answers: ["Vincennes","Saint-Lô","Cherbourg","Le Pin-au-Haras"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  }, 
  id2302: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle nation le poney Connemara est-il originaire ?",
    answers: ["Écosse","Irlande","Pays de Galles","Islande"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2303: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel célèbre poney Connemara a marqué l'histoire du saut d'obstacles international avec le cavalier Jean-Marc Nicolas ?",
    answers: ["Jappeloup","Stroller","Dexter Leam Pondi","Milton"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2304: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment s'appelle le premier poney né en 1904 inscrit au stud-book de la race du Connemara. ?",
    answers: ["Jappeloup","Sampson","Dexter Leam Pondi","Cannon Ball "],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2305: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire le poney Exmoor ?",
    answers: ["Pays de Galles","Écosse","Angleterre","Irlande"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2306: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la couleur de robe unique et obligatoire chez l'Exmoor ?",
    answers: ["Gris","Pie","Bai","Noir"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2307: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Par quel symbole les poulains sont-il marqués sur l'épaule droite pour indiqué leur appartenance à la race Exmoor ?",
    answers: ["Croix","Carré","Etoile","Triangle"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2308: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays la race de cheval miniature Falabella est-elle originaire ?",
    answers: ["Mexique","Argentine","Brésil","Chili"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2309: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la taille maximale autorisée pour qu'un Falabella soit reconnu dans le stud-book ?",
    answers: ["76 cm","96 cm","116 cm","136 cm"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2311: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire la race de poney Fjord ?",
    answers: ["Suède","Finlande","Norvège","Islande"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2312: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la couleur de robe quasi unique du cheval Fjord déclinée en plusieurs nuances ?",
    answers: ["Alezan","Isabelle","Gris","Noir"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2313: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle marque primitive sombre parcourt tout le dos du Fjord, de la crinière à la queue ?",
    answers: ["Une liste","Une raie de mulet","Une balzane","Une pommelure"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2314: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel peuple utilisait déjà les ancêtres du Fjord pour la guerre et le travail agricole ?",
    answers: ["Les Celtes","Les Vikings","Les Saxons","Les Romains"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2315: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle région montagneuse le cheval Haflinger est-il originaire ?",
    answers: ["Les Pyrénées","Le Tyrol","Les Highlands","Les Andes"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2316: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la seule robe autorisée pour le Haflinger selon les standards actuels du stud-book ?",
    answers: ["Gris pommelé","Noir","Alezan aux crins lavés","Bai brun"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2317: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle plante figure sur la marque au fer rouge traditionnelle appliquée aux Haflinger ?",
    answers: ["Un trèfle","Une fraise","Un edelweiss","Une passe-rose"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2318: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment s'appelait l'étalon fondateur né en 1874, dont descendent tous les Haflingers actuels ?",
    answers: ["Folio","Folie","Haflo","Tyrol"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2319: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quelle région du Royaume-Uni la race du poney Highland a-t-elle vu le jour ?",
    answers: ["Pays de Galles","Écosse","Cornouailles","Irlande du Nord"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2320: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle reine britannique était une grande admiratrice et éleveuse de poneys Highland à Balmoral ?",
    answers: ["Reine Victoria","Reine Anne","Reine Élisabeth II","Reine Marie"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2321: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la couleur de robe 'souris' très typique de la race de poney Highland ?",
    answers: ["Louvet","Grullo","Alezan","Pie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2322: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quel pays est originaire le poney New Forest ?",
    answers: ["Pays de Galles","Écosse","Irlande","Angleterre"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2323: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans quel comté du sud de l'Angleterre se situe la forêt dont le poney New Forest tire son nom ?",
    answers: ["Hampshire","Cornouailles","Kent","Devon"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2324: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle couleur n'est pas acceptée au stud book pour le New Forest?",
    answers: ["Bai","Alezan","Gris","Pie"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2325: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les propriétaires locaux qui ont le droit ancestral de laisser leurs poneys New Forest en liberté dans la forêt ?",
    answers: ["Les Commoners","Les Rangers","Les Farmers","Les Lords"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2326: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle est la taille maximale autorisée au garrot pour un poney New Forest pour être inscrit au stud book ?",
    answers: ["1,20 m","1,35 m","1,60 m","1,48 m"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2327: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les poneys Shetland dont la taille ne dépasse pas 86 cm ?",
    answers: ["Les Mini-Shetland","Les Falabellas","Les Poneys-jouets","Les Micro-Shetland"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2328: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle robe est formellement interdite par le stud-book du poney Shetland ?",
    answers: ["Noir","Pie","Appaloosa","Alezan"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2329: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "De quelle nation du Royaume-Uni le poney Welsh est-il originaire ?",
    answers: ["L'Écosse","Le Pays de Galles","L'Irlande","L'Angleterre"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2330: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la variété du Welsh qui est la plus petite et la plus ancienne ?",
    answers: ["Welsh Pony","Welsh Mountain","Welsh Cob","Welsh Sport"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2331: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la variété du Welsh qui est la plus grande ?",
        answers: ["Welsh Pony","Welsh Mountain","Welsh Cob","Welsh Sport"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2332: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle robe est strictement interdite dans le standard de la race Welsh ?",
    answers: ["Gris","Alezan","Bai","Pie"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2333: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la robe d'un cheval qui a les poils marron/fauve, mais les crins (crinière et queue) et le bas des membres noirs ?",
    answers: ["Alezan","Bai","Noir","Isabelle"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2334: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle robe se caractérise par des poils et des crins de couleur marron-orangé, sans aucun poil noir ?",
    answers: ["Alezan","Bai","Palomino","Gris"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2335: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on un cheval dont la robe est composée de plaques de blanc et d'une autre couleur ?",
    answers: ["Aubère","Pie","Rouan","Pommelé"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2336: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle couleur de robe est caractérisée par des poils dorés et des crins blancs (souvent dits 'crins lavés') ?",
    answers: ["Isabelle","Palomino","Souris","Alezan"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2337: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les taches blanches situées sur les membres du cheval (souvent au niveau du boulet ou du paturon) ?",
    answers: ["Des listes","Des hermines","Des ladres","Des balzanes"],
    correctAnswer: 3,
    box: 1,
    doneToday: null
  },
  id2338: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on la marque blanche sur le front du cheval lorsqu'elle est ronde ou ovale ?",
    answers: ["Une pelote","Une liste","Une belle-face","Un ladre"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  },
  id2339: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle robe désigne un cheval aux poils gris-souris avec les crins et le bas des membres noirs ?",
    answers: ["Louvet","Souris","Aubère","Gris fer"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2340: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment nomme-t-on un mélange de poils blancs et d'un fond de robe rouge (alezan) ?",
    answers: ["Gris","Aubère","Rouan","Pie-rouge"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2341: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel terme désigne la zone rose sans pigments, située généralement autour des naseaux ou de la bouche ?",
    answers: ["La liste","Le ladre","Le vairon","Le chanfrein"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2342: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on un cheval mâle qui a été castré ?",
    answers: ["Un étalon","Un hongre","Un entier","Un poulain"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2343: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle partie de l'anatomie du cheval correspond à l'arrière-main, située entre les reins et la queue ?",
    answers: ["Le garrot","La croupe","Le poitrail","Le grasset"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2344: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on l'allure particulière à deux temps où le cheval déplace simultanément les deux membres d'un même côté ?",
    answers: ["Le galop","Le trot","L'amble","Le pas"],
    correctAnswer: 2,
    box: 1,
    doneToday: null
  },
  id2345: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quelle partie du membre du cheval se situe entre le boulet et le genou (ou le jarret) ?",
    answers: ["Le pâturon","Le canon","La couronne","L'épaule"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
  id2346: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on les longs poils situés au-dessus du sabot et derrière le boulet, très fournis chez les chevaux de trait ?",
    answers: ["Les crins","Les fanons","Les moustaches","Les jarres"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2347: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Dans le jargon militaire ou des haras, comment appelle-t-on le service chargé de fournir des chevaux aux cavaliers pour qu'ils puissent remonter à cheval après avoir été démontés ?",
    answers: ["Le dressage","La remonte","Le débourrage","L'enrôlement"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2348: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Quel terme désigne un étalon utilisé pour apporter des qualités spécifiques et faire progresser la génétique d'une autre race ?",
    answers: ["Un réformé","Un améliorateur","Un reproducteur passif","Un étalon d'agrément"],
    correctAnswer: 1,
    box: 1,
    doneToday: null
  },
   id2349: {
    themes: ["Science et Nature","Nature","Animaux","Chevaux","Divers"],
    question: "Comment appelle-t-on l'équipement (selle spéciale) permettant à un cheval de porter de lourdes charges sans cavalier ?",
    answers: ["Le bât","Le harnais","Le licol","La bricole"],
    correctAnswer: 0,
    box: 1,
    doneToday: null
  }
  };
  export default dataScience;
//  module.exports = dataScience;